export default "__VITE_ASSET__a69524bb__"